/**
 * <s-header-shrink> — sets [data-header-compact] on <html> while the shopper scrolls down past the top
 * of the page, and removes it when they scroll back up or return near the top. Markup reacts with
 * `[[data-header-compact]_&]:` utilities, so without JavaScript the header simply stays full size.
 */
class SHeaderShrink extends HTMLElement {
  #lastY = 0;
  #ticking = false;
  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    window.requestAnimationFrame(() => {
      this.#ticking = false;
      this.update();
    });
  };

  connectedCallback() {
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    document.documentElement.removeAttribute('data-header-compact');
  }

  update() {
    const y = window.scrollY;
    const delta = y - this.#lastY;
    const root = document.documentElement;
    if (y < 120) {
      root.removeAttribute('data-header-compact');
    } else if (y > 220 && delta > 6) {
      root.setAttribute('data-header-compact', '');
    } else if (delta < -10) {
      root.removeAttribute('data-header-compact');
    }
    if (Math.abs(delta) > 6 || y < 120) this.#lastY = y;
  }
}

if (!customElements.get('s-header-shrink')) customElements.define('s-header-shrink', SHeaderShrink);
